import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {$translate} from "../../services/internationalization/localize.service";
import {SavedFiltersItemModel} from "./saved-filters-item.model";
import {DropDownButton} from "@syncfusion/ej2-angular-splitbuttons";
import {ListViewComponent} from "@syncfusion/ej2-angular-lists";
import {SelectEventArgs} from "@syncfusion/ej2-lists/src/list-view/list-view";
import {QueryFiltersSavedQueryModel} from "../query-filters/query-filters-saved-query.model";
import {UserService} from "../../services/user/user.service";
import {LocationService} from "../../services/location/location.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'sb-saved-filters',
  templateUrl: './saved-filters.component.html',
  styleUrls: ['./saved-filters.component.scss']
})
export class SavedFiltersComponent implements OnInit {
  @ViewChild('dropdown') dropdown: DropDownButton;
  @ViewChild('savedFiltersView') savedFiltersListView: ListViewComponent;

  @Input('addToUrl')
  addToUrl: boolean = false;

  @Output('select')
  onSelectFilterEmitter: EventEmitter<QueryFiltersSavedQueryModel> = new EventEmitter()

  @Output('clear')
  onClearFilterEmitter: EventEmitter<void> = new EventEmitter()

  savedFilterItems: any[] = [];

  label: string;

  showClearFilters: boolean = true;

  SAVED_FILTERS_QUERY_PARAM: string = "savedFilter";
  private selectedFilterId: string;

  /**
   * Used to fetch all queries related to a given owner entity Kanban board, table list ...
   */
  @Input("savedQueryOwner")
  set savedQueryOwnerKey(savedQueryOwnerKey: string) {
    this._savedQueryOwnerKey = savedQueryOwnerKey;
    this.loadSavedFilters();
  }

  get savedQueryOwnerKey(): string {
    return this._savedQueryOwnerKey;
  }

  private _savedQueryOwnerKey: string;


  constructor(private userService: UserService,
              private locationService: LocationService,
              private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      const selectedFilter = queryParams[this.SAVED_FILTERS_QUERY_PARAM];
      if (selectedFilter && selectedFilter.trim().length > 0) {
        this.selectedFilterId = this.nameToId(selectedFilter);
      }
    });

    this.label = $translate("ng.component.saved-filters.label")`Saved filters`;
  }

  public async saveItem(name: string, query: string) {
    if (name && query && this.savedQueryOwnerKey) {
      const id = this.nameToId(name);
      this.savedFilterItems.push({id: id, text: name, filter: query} as SavedFiltersItemModel);
      this.savedFiltersListView.refresh();

      await this.userService.updateUserProfileSetting(this.savedQueryOwnerKey, JSON.stringify(this.savedFilterItems));
    }
  }

  onSelectFilter(e: SelectEventArgs) {
    const filterItem = {filter: e.data['filter'], text: e.data['text'], id: e.data['id']} as SavedFiltersItemModel;
    this.applyFilter(filterItem);
  }

  loadSavedFilters() {
    if (this.savedQueryOwnerKey) {
      let savedFilters = this.userService.getUserProfileProperty(this.savedQueryOwnerKey, "[]")
      this.savedFilterItems = savedFilters ? JSON.parse(savedFilters) : [];
      if (this.selectedFilterId) {
        const selectedFilterItem = this.savedFilterItems.filter((f: SavedFiltersItemModel) => f.id == this.selectedFilterId)[0]
        this.applyFilter(selectedFilterItem);
      }
    }
  }

  onClearFilters(e: MouseEvent) {
    this.onClearFilterEmitter.emit();
    this.locationService.deleteLocationQueryParams([this.SAVED_FILTERS_QUERY_PARAM]);


    // Somehow after clearing the filters the saved items are not clickable anymore, this seems to help prevents the issue
    // but might not be the best to properly resolve the lock issue
    this.savedFiltersListView.refresh();
  }

  private applyFilter(filterItem: SavedFiltersItemModel) {
    if (filterItem) {
      this.onSelectFilterEmitter.emit({name: filterItem.text, query: filterItem.filter});
      if (this.addToUrl) {
        let queryParams = {[this.SAVED_FILTERS_QUERY_PARAM]: filterItem.id};
         this.locationService.mergeLocationQueryParams(queryParams);
      }
    } else {
      this.locationService.deleteLocationQueryParams([this.SAVED_FILTERS_QUERY_PARAM]);
    }
  }

  nameToId(name: string): string {
    return name.trim().toLowerCase().replace(' ', '_');
  }

  protected readonly console = console;
  protected readonly JSON = JSON;
}
